import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
})
export class GuideComponent implements OnInit {
  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }
  close(data?) {
    this.modalController.dismiss(data);
  }
}
